<!--I have removed all conditions from here because all Coming-soon scenarions are
handleled by routes and guards-->
@if (showCookieOverlay()) {
        <div class="cookie-consent-overlay">
        <div class="cookie-consent-placeholder">
            <div class="cookie-consent-placeholder__bar"></div>
            <div class="cookie-consent-placeholder__bar cookie-consent-placeholder__bar--medium"></div>
            <div class="cookie-consent-placeholder__bar cookie-consent-placeholder__bar--short"></div>
            <div class="cookie-consent-placeholder__actions">
                <div class="cookie-consent-placeholder__btn cookie-consent-placeholder__btn--wide"></div>
                <div class="cookie-consent-placeholder__btn"></div>
                <div class="cookie-consent-placeholder__btn cookie-consent-placeholder__btn--outline"></div>
            </div>
        </div>
    </div>

}

<div #scrollElement></div>

<header id="main-header" [ngClass]="{ 'no-animation': noAnimation }">
    <app-header></app-header>
</header>

<main id="main-content">
    @if (showCountrySelectionPanel()) {
        <app-country-selector></app-country-selector>
    }
    @if (!showCountrySelectionPanel()) {
        <router-outlet></router-outlet>
    }
</main>

@if (showLoginForNonProdEnviorment) {
    <app-generic-login-page></app-generic-login-page>
}

@if (showToast) {
    <div>
        <app-toast
            [message]="toastMessage"
            [toastType]="toastType"
            [position]="position"
            [leftPosition]="leftPosition"
        >
        </app-toast>
    </div>
}

@if (showNotification) {
    <div>
        <app-notification></app-notification>
    </div>
}

<footer>
    <app-footer (scrollToTop)="scrollTop()"></app-footer>
</footer>

<div class="language-picker">
    @if (showLangPicker) {
        <app-language-selection-page></app-language-selection-page>
    }
</div>

<div class="lightbox">
    @if (showLightBox) {
        <app-lightbox></app-lightbox>
    }
</div>
